import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from 'libs/user/user.service';
import { AuthorizationService } from 'libs/authorization/authorization.service';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

/**
 * S2-02 — porte d'entrée de l'app admin. Décide désormais contre adminGrants
 * (AuthorizationService), pas contre users/{id}.isAdmin directement. Repli
 * sur isAdmin uniquement si l'identité n'a strictement aucun droit migré,
 * pour ne jamais bloquer un admin faute de migration déjà passée.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthAdminGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private authorizationService: AuthorizationService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userService.authGuardUser$.pipe(
      switchMap((user) => {
        if (!user) {
          if (!state.url.includes('login')) {
            this.router.navigateByUrl('login');
            return of(false);
          }
          return of(true);
        }

        return this.authorizationService.hasAnyAdminGrant(user.id).pipe(
          switchMap((hasGrant) =>
            // Aucun droit migre pour cette identite : repli sur le champ
            // historique plutot que de la bloquer.
            hasGrant ? of(true) : of(user.isAdmin === true),
          ),
          map((estAdmin) => {
            if (!estAdmin && !state.url.includes('login')) {
              this.router.navigateByUrl('login');
              return false;
            }

            if (estAdmin && state.url.includes('login')) {
              this.router.navigateByUrl('/');
              return false;
            }

            return true;
          }),
        );
      }),
    );
  }
}
